var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIvstTdy03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1017_6803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6931 17.7083C12.7859 17.8013 12.8962 17.875 13.0176 17.9253C13.139 17.9757 13.2691 18.0016 13.4006 18.0016C13.532 18.0016 13.6621 17.9757 13.7835 17.9253C13.9049 17.875 14.0152 17.8013 14.1081 17.7083L25.6931 6.29329C25.7859 6.20031 25.8962 6.12655 26.0176 6.07623C26.139 6.0259 26.2691 6 26.4006 6C26.532 6 26.6621 6.0259 26.7835 6.07623C26.9049 6.12655 27.0152 6.20031 27.1081 6.29329L30.1081 9.24329C30.201 9.33616 30.2748 9.44645 30.3251 9.56785C30.3754 9.68924 30.4013 9.81937 30.4013 9.95079C30.4013 10.0822 30.3754 10.2123 30.3251 10.3337C30.2748 10.4551 30.201 10.5654 30.1081 10.6583L14.0581 26.7083C13.9652 26.8013 13.8549 26.875 13.7335 26.9253C13.6121 26.9757 13.482 27.0016 13.3506 27.0016C13.2191 27.0016 13.089 26.9757 12.9676 26.9253C12.8462 26.875 12.7359 26.8013 12.6431 26.7083L3.69305 17.7083C3.50566 17.5208 3.40039 17.2665 3.40039 17.0014C3.40039 16.7363 3.50566 16.4821 3.69305 16.2945L6.69305 13.2945C6.78593 13.2016 6.89621 13.1278 7.01761 13.0775C7.13901 13.0272 7.26914 13.0013 7.40055 13.0013C7.53197 13.0013 7.66209 13.0272 7.78349 13.0775C7.90489 13.1278 8.01518 13.2016 8.10805 13.2945L12.6931 17.7083Z",
    stroke: "#0E9CEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1017_6803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.400391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIvstTdy03);
export default __webpack_public_path__ + "static/media/icon-ivst-tdy-03.907626abc8a0a5ee54769e73bbd965b5.svg";
export { ForwardRef as ReactComponent };